import React, { useState } from "react";
import "../../communication.css";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";

const initialSort = [
  {
    field: "name",
    dir: "asc",
  },
];

export const ReviewRecipientList = (props) => {
  const [sort, setSort] = useState(initialSort);
  const [skip, setSkip] = useState(0);
  const pageChange = (event) => {
    setSkip(event.page.skip);
  };
  return (
    <>
      <Grid
        data={orderBy(props.data, sort).slice(skip, skip + 25)}
        style={{ height: "400px" }}
        sortable={"virtual"}
        sort={sort}
        pageSize={25}
        total={props.data.length}
        skip={skip}
        scrollable={"virtual"}
        onPageChange={pageChange}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <GridColumn field="name" title="Name" />
        <GridColumn field="id" title="SAP No" />
        <GridColumn field="depot" title="Department/Depot" />
        <GridColumn field="interchange" title="Section/Interchange Group" />
        <GridColumn field="designation" title="Designation" />
        {/* <GridColumn field="leadership" title="Leadership" />
                <GridColumn field="citizenship" title="Citizenship" />
                <GridColumn field="nationality" title="Nationality" /> */}
      </Grid>
    </>
  );
};
